import axios from "axios";

export default class Question {
  constructor(question) {
    // _props are the first question's original properties
    // prop is the _cache[_active] prop
    this._active = null;
    this._cache = {};
    this._cache[question.lang] = {};
    this._default = question.lang;
    this._id = question.id;
    this._category = question.category;
    this._section = question.section;
    this._num = question.num;
    this._questionnaire_num = question.questionnaire_num;
    this._favorite = question.favorite;
    this._soundPlaying = question.soundPlaying;
    this._removeExplanation = question.removeExplanation;
    this._slug = question.slug;

    // test related fields, pointing to options not ids
    this.tempSelectedOption = null;
    this.selectedOption = null;

    for (let prop in question) {
      this._cache[question.lang][prop] = question[prop];
      Object.defineProperty(this, prop, {
        get: function() {
          return this._active[prop];
        }
      });
    }

    this._active = this._cache[question.lang];
  }

  get originalId() {
    return this._id;
  }

  answerWithSelected() {
    this.selectedOption = this.tempSelectedOption;
    //this.tempSelectedOption = null;
  }

  isCorrect() {
    return this.selectedOption.is_correct;
  }

  changeLang(lang) {
    if (this._active === this._cache[lang]) return; //if already the same
    if (lang in this._cache) {
      this._active = this._cache[lang];
      this.tempSelectedOption = null;
    } else {
      axios
        .get(this.url + "/translation/" + lang + ".json")
        .then(({ data }) => {
          this._cache[lang] = Question.parseSingle(data, {
            removeExplanation: this._removeExplanation
          });
          this._active = this._cache[lang];
          this.tempSelectedOption = null;
        })
        .catch(() => console.log("No translation found."));
    }
  }

  handleFavorite() {
    this._favorite ? this.postUnfavorite() : this.postFavorite();
  }

  postFavorite() {
    axios.post(this.postUrl).then(() => (this._favorite = true));
  }

  postUnfavorite() {
    axios.delete(this.postUrl).then(() => (this._favorite = false));
  }

  get isFavorite() {
    return this._favorite;
  }

  get url() {
    //return '/erotiseis/' + this._id;
    return "/erotiseis/" + this._slug;
  }

  get postUrl() {
    return this.url + "/favorite";
  }

  get label() {
    return {
      1: { category: "a", icon: "fa-motorcycle", text: "μηχανη" },
      2: { category: "b", icon: "fa-car", text: "αυτοκινητο" },
      3: { category: "c", icon: "fa-truck", text: "φορτηγο" },
      4: { category: "d", icon: "fa-bus", text: "λεωφορειο" },
      6: { category: "peig", icon: "fa-truck", text: "πει φορτηγο" },
      7: { category: "peid", icon: "fa-bus", text: "πει λεωφορειο" },
      8: { category: "taxi", icon: "fa-taxi", text: "taxi" }
    }[this._category];
  }

  get explanationId() {
    return "explanation-" + this._id;
  }

  get bookReference() {
    return this._questionnaire_num
      ? this._section + " " + this._questionnaire_num + "." + this._num
      : this._section + " " + this._num;
  }

  get playing() {
    return this._soundPlaying;
  }

  set playing(value) {
    this._soundPlaying = value;
  }

  /**
   *
   * Static class methods
   *
   */

  static processSound(sound) {
    if (sound) return `https://www.drivepoint.gr/test_sounds/${sound}.mp3`;
    return null;
  }

  static shuffle(array) {
    let counter = array.length;
    while (counter > 0) {
      let index = Math.floor(Math.random() * counter);
      counter--;
      let temp = array[counter];
      array[counter] = array[index];
      array[index] = temp;
    }
    return array;
  }

  /**
   *
   * @param {Object} data Contains questions, favorites, user_options
   * @returns {*}
   */
  static parse(data, options = {}) {
    data.questions = data.questions.map(question => {
      // let q = JSON.parse(question);
      let q = question;
      q.favorite = false;
      q.sound = Question.processSound(q.sound);
      q.soundPlaying = false;
      if (q.image) q.image = "https://www.drivepoint.gr" + q.image;
      if (options.removeExplanation) {
        q.explanation = q.explanation_img = null;
        q.removeExplanation = true; // use this to hide explanations for translations as well
      }
      q.options.forEach(
        (option, idx, self) =>
          (self[idx].sound = Question.processSound(self[idx].sound))
      );
      // shuffle options
      q.options = Question.shuffle(q.options);
      return new Question(q);
    });
    return data.questions;
  }

  static parseSingle(question, options) {
    question.favorite = false; // does not matter
    question.sound = Question.processSound(question.sound);
    question.soundPlaying = false;
    if (options.removeExplanation)
      question.explanation = question.explanation_img = null;
    question.options.forEach(
      (option, idx, self) =>
        (self[idx].sound = Question.processSound(self[idx].sound))
    );
    question.options = Question.shuffle(question.options);
    return question;
  }
}
